import { action, observable, makeObservable } from 'mobx'
import { task } from 'mobx-task'
import ModalViewModel from 'infra/ModalViewModel'

/**
 * View Model for collecting payment.
 */
export default class SettleBalanceViewModel extends ModalViewModel {
  @observable state = SettleBalanceState.AwaitingConfirmation

  constructor(
    private _settleBalance: () => Promise<unknown>,
    private _revealEvents: () => void
  ) {
    super()
    makeObservable(this)
    this.show$.subscribe(this.reset)
  }

  /**
   * Settle the balance..
   */
  settle = task.resolved(async () => {
    try {
      await this._settleBalance()
      this.setState(SettleBalanceState.Success)
    } catch (err: unknown) {
      console.error('Settle Balance failed.', err)
      this.setState(SettleBalanceState.Failed)
    }
  })

  /**
   * Resets the state.
   */
  @action.bound
  reset() {
    this.settle.reset()
    this.setState(SettleBalanceState.AwaitingConfirmation)
  }

  /**
   * Sets the payment collection state.
   *
   * @param state
   */
  @action.bound
  setState(state: SettleBalanceState) {
    this.state = state
  }

  /**
   * Closes the dialog and reveals the events tab.
   */
  @action.bound
  goToEvents() {
    this.close()
    this._revealEvents()
  }
}

/**
 * Describes the state of the view model.
 */
export enum SettleBalanceState {
  /**
   * We are waiting for the user to confirm that they want
   * to collect payment.
   */
  AwaitingConfirmation,
  /**
   * Client will be notified or charged, depending on their payment info status.
   */
  Success,
  /**
   * Something went wrong while executing the settle balance command, could be a
   * validation error or something transient.
   */
  Failed,
}
